if (!customElements.get('collection-nav')) {
  customElements.define(
    'collection-nav',
    class extends HTMLElement {
      constructor() {
        super();

        this.select = this.querySelector('#collection-nav-select');
        this.select.addEventListener('change', this.onSelectChange.bind(this));

        this.gridViewOptions = this.querySelectorAll('.grid-view-option');
        this.gridViewOptions.forEach((button) => {
          button.addEventListener('click', this.onGridViewChange.bind(this));
        });

        this.firstColumnClick = true;
      }

      onSelectChange(event) {
        window.location.href = event.target.value;
      }

      onGridViewChange(event) {
        const gridPreference = event.currentTarget.dataset.grid;
        document.documentElement.setAttribute('data-grid', gridPreference);
        const productGrid = document.querySelector('#product-grid');

        if (gridPreference === '1' && this.firstColumnClick) {
          this.firstColumnClick = false;
          const images = productGrid.querySelectorAll('img');
          images.forEach((img) => {
            img.sizes = '(min-width: 750px) calc(100vw - 100px), calc(100vw - 30px)';
          });
        }

        localStorage.setItem('gridPreference', gridPreference);
      }
    }
  );
}
